'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

var _messages = require('../messages');

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var configureApi = _ref.configureApi,
      loginSuccess = _ref.loginSuccess,
      logoutSuccess = _ref.logoutSuccess,
      tokenExpired = _ref.tokenExpired;


  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {

        var hasLoggedIn = action.type == _constants.USER_AUTHENTICATE_SUCCESS || action.type == _constants.USER_REGISTER_SUCCESS;

        if (hasLoggedIn) {
          var user = action.data;
          configureApi(user.accessToken);
          loginSuccess(user, dispatch);
        }

        if (action.type == _constants.USER_LOGOUT_SUCCESS) {
          next(action);
          configureApi(null);
          logoutSuccess(dispatch);
          return;
        }

        if (action.type == _constants.USER_UPDATE_ACCESSTOKEN) {
          configureApi(action.accessToken);
        }

        var userLoad = action.type === _constants.USER_LOAD_SUCCESS || action.type === _constants.USER_LOAD_FAILURE;

        if (userLoad && !action.data) {

          var message = Array.isArray(action.errors) && action.errors[0] && action.errors[0].message;

          var isNetworkError = message === _messages2.default.CONNECTIVITY_ERROR;

          if (!isNetworkError) {
            configureApi(null);
            logoutSuccess(dispatch);

            if (tokenExpired) tokenExpired(dispatch);
          }
        }

        next(action);
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/middleware/user.js
// module id = 430
// module chunks = 0